"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_scroll_memory_1 = __importDefault(require("react-router-scroll-memory"));
const bit_utils_context_1 = require("@gcloud-npm/bit.utils.context");
const bit_unifiedcomponents_stopper_1 = __importStar(require("@gcloud-npm/bit.unifiedcomponents.stopper"));
const context_1 = require("./Reducers/context");
const createRouter_1 = __importDefault(require("./createRouter"));
const ErrorBoundary_1 = __importDefault(require("./ErrorBoundary"));
class Core extends react_1.Component {
    constructor(props) {
        super(props);
        this.componentWillUnmount = () => {
            try {
                const { projectId } = this.props;
                window.nookInfoExchange.cleanObserver(bit_utils_context_1.QUEUE_NAMES.GLOBAL, `MainAppControllerListener-${projectId}-keepContextUpdated`);
            }
            catch (err) {
                //
            }
        };
        this.componentDidMount = () => {
            const { projectId } = this.props;
            window.nookInfoExchange.registerAsObserver(bit_utils_context_1.QUEUE_NAMES.GLOBAL, `MainAppControllerListener-${projectId}-keepContextUpdated`, (context) => {
                this.props.setContextData(context);
            }, false);
            // Lógica testAB
            window.nookInfoExchange.registerAsObserver(bit_utils_context_1.QUEUE_NAMES.GLOBAL, `MainAppControllerListener-${projectId}`, (context) => {
                window.nookInfoExchange.cleanObserver(bit_utils_context_1.QUEUE_NAMES.GLOBAL, `MainAppControllerListener-${projectId}`);
                this.setState({ contextData: context });
                // enviamos el evento aunque no haga nada
                window.nookInfoExchange.sendMessage('CUSTO_TEST_VERSION', {
                    testDisable: true,
                    testVersion: '',
                    testName: '',
                });
            });
        };
        this.state = {
            contextData: null,
        };
    }
    render() {
        const { projectId, history, urlLibrary, modulesLibrary, defaultErrorScreen, inPageError, } = this.props;
        const { contextData } = this.state;
        if (!contextData) {
            // fake o algo timeout de error...
            return react_1.default.createElement("div", { className: "mainContent xux loading" });
        }
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement("div", { id: "mainContent", className: "mainContent xux" },
                react_1.default.createElement(ErrorBoundary_1.default, { history: history, projectId: projectId, defaultErrorScreen: defaultErrorScreen, contextData: contextData },
                    inPageError && (react_1.default.createElement(bit_unifiedcomponents_stopper_1.default, { theme: bit_unifiedcomponents_stopper_1.THEMES.EMPTY, content: inPageError.errorType, contentProps: inPageError.errorInfo, projectId: projectId })),
                    !inPageError &&
                        (0, createRouter_1.default)(urlLibrary, modulesLibrary, contextData, projectId)),
                react_1.default.createElement(react_router_scroll_memory_1.default, null))));
    }
}
const mapStateToProps = (state) => ({
    inPageError: state.errorCatcher.inPageError,
});
const mapDispatchToProps = (dispatch) => {
    return {
        setContextData: (data) => dispatch(context_1.actions.setContextData(data)),
    };
};
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(Core);
//# sourceMappingURL=Core.js.map